import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/_components/ui/tooltip'
import type { TIncomeDeltaDTO } from '@doutorsim/shared/exposed/person-declarations'

interface IncomeDeltaProps {
  delta: TIncomeDeltaDTO
}

const TIER_STYLES: Record<TIncomeDeltaDTO['tier'], { className: string; tooltip: string }> = {
  minimal: {
    className: 'bg-brand-grayscale-3 text-brand-grayscale-8',
    tooltip: 'Variação mínima',
  },
  moderate: {
    className: 'bg-amber-100 text-amber-800',
    tooltip: 'Variação moderada',
  },
  divergent: {
    className: 'bg-aux-red-danger-2 text-aux-red-danger-8',
    tooltip: 'Salário divergente',
  },
}

const formatPercentage = (signedPercentage: number) => {
  const sign = signedPercentage >= 0 ? '+' : '−'
  const formatted = Math.abs(signedPercentage).toFixed(1).replace('.', ',')
  return `${sign}${formatted}%`
}

export const IncomeDelta = ({ delta }: IncomeDeltaProps) => {
  const { className, tooltip } = TIER_STYLES[delta.tier]

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`inline-flex cursor-help items-center rounded-sm px-1.5 py-0.5 text-xs font-semibold tabular-nums ${className}`}
          >
            {formatPercentage(delta.signedPercentage)}
          </span>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
